export default {
  routes: [
    {
      name: 'accountingForms',
      path: '/directory/accounting-forms',
      component: () => import('./views/TheAccountingForms.vue'),
    },
  ]
}
